/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



import {AbstractControlDirective} from './abstract_control_directive';
import {ControlContainer} from './control_container';
import {ControlValueAccessor} from './control_value_accessor';
import {AsyncValidator, AsyncValidatorFn, Validator, ValidatorFn} from './validators';
/**
 * @return {?}
 */
function unimplemented(): any {
  throw new Error('unimplemented');
}
/**
 * A base class that all control directive extend.
 * It binds a {\@link FormControl} object to a DOM element.
 * 
 * Used internally by Angular forms.
 * 
 * \@stable
 * @abstract
 */
export abstract class NgControl extends AbstractControlDirective {
/**
 * \@internal
 */
_parent: ControlContainer|null = null;
  name: string|null = null;
  valueAccessor: ControlValueAccessor|null = null;
/**
 * \@internal
 */
_rawValidators: Array<Validator|ValidatorFn> = [];
/**
 * \@internal
 */
_rawAsyncValidators: Array<AsyncValidator|AsyncValidatorFn> = [];
/**
 * @return {?}
 */
get validator(): ValidatorFn|null { return /** @type {?} */(( <ValidatorFn>unimplemented())); }
/**
 * @return {?}
 */
get asyncValidator(): AsyncValidatorFn|null { return /** @type {?} */(( <AsyncValidatorFn>unimplemented())); }
/**
 * @abstract
 * @param {?} newValue
 * @return {?}
 */
viewToModelUpdate(newValue: any) {}
}

function NgControl_tsickle_Closure_declarations() {
/**
 * \@internal
 * @type {?}
 */
NgControl.prototype._parent;
/** @type {?} */
NgControl.prototype.name;
/** @type {?} */
NgControl.prototype.valueAccessor;
/**
 * \@internal
 * @type {?}
 */
NgControl.prototype._rawValidators;
/**
 * \@internal
 * @type {?}
 */
NgControl.prototype._rawAsyncValidators;
}

